import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { STEP_EXECUTION_EXTRACT_ENTITIES_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_extract_entities_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { ExtractEntities } from '@/types/extract.ts';

const useRetrieveExtractEntities = (
  stepExecutionId?: string,
): UseQueryResult<ExtractEntities, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: STEP_EXECUTION_EXTRACT_ENTITIES_KEY(automationId, stepExecutionId),
    queryFn: async () => {
      const response = await apiClient.get(get_extract_entities_url(stepExecutionId));
      return response.data;
    },
    enabled: !!stepExecutionId,
  });
};

export default useRetrieveExtractEntities;
